module.exports = __webpack_public_path__ + "static/media/Teams.00f7d911.png";